module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/alexanderlaing/Sites/st-enoch/wp-content/themes/digitalimpact/node_modules/axios/index.js
// module id = 30
// module chunks = 0